import { Pipe, PipeTransform } from "@angular/core";
import { isInteger } from '@ng-bootstrap/ng-bootstrap/util/util';
import format from "date-fns/format";
import isDate from "date-fns/isDate";
import parse from "date-fns/parse";

@Pipe({
    name: "dateFns",
})
export class DateFnsPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        let date = value;
        if (!isDate(value)) {
            date = new Date(value);
        }

        if (isDate(date)) {
            let processed = format(date, args);
            const found = processed.match(/(\d)o\b/);
            if (found && found[1]) {
                processed = processed.replace(/\do/, this.parseOrdinal(found[1]));
            }

            return processed;
        }
    }

    parseOrdinal(int): string {
        const ones = +int % 10;
        const tens = +int % 100 - ones;

        return int + ['th', 'st', 'nd', 'rd'][ tens === 10 || ones > 3 ? 0 : ones ];
    }
}
